import { render } from "./CatalogNavigation.vue?vue&type=template&id=5210a2ca&scoped=true"
import script from "./CatalogNavigation.vue?vue&type=script&lang=js"
export * from "./CatalogNavigation.vue?vue&type=script&lang=js"

import "./CatalogNavigation.vue?vue&type=style&index=0&id=5210a2ca&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5210a2ca"]])

export default __exports__